import { FaDownload, FaEllipsisH, FaFilter, FaRecycle, FaUpload } from 'react-icons/fa';
import * as XLSX from 'xlsx';

import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DeliveryListe.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Pagination, PaginationItem, PaginationLink, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBoxOpen, FaCalendarAlt, FaCheckCircle, FaClock, FaEdit, FaFileExport, FaFileInvoice, FaFilePdf, FaInfoCircle, FaPlus, FaScrewdriver, FaSearch, FaTrash, FaTruck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { devisActions } from '../../sagas/devisSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { convertNumberToWords, formatPrice, roundToNearestInteger } from '../../helpers/utility';
import Select from "react-select";
import { clientActions } from '../../sagas/clientSlice';
import { commercialActions } from '../../sagas/commercialSlice';
import { companyActions } from '../../sagas/companySlice';
import useSessionState from '../../hooks/useSessionState';
import { generateDoc } from '../../helpers/generateDoc';

const DeliveryList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { list, loading } = useSelector((state) => state.deliveryNotes);
    const { t } = useTranslation();
    const [checkedDeliveries, setCheckedDeliveries] = useState([]); // State to track checked deliveries
    const clients = useSelector(state => state.clients.clients);
    const { companies } = useSelector(state => state.companies);
    const { list: commercialList, loading: commercialLoading } = useSelector((state) => state.commercials); // Adjust state path as needed
    const { company, businessName, role, address, telephone } = useSelector(state => state.auth);
    const isSuperAdmin = role === 'ROLE_SUPER_ADMIN';

    const fileInputRef = useRef(null);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const getMonthDateRange = (monthValue) => {
        if (!monthValue) {
            return { dateFrom: '', dateTo: '' };
        }

        const [year, month] = monthValue.split('-').map(Number);
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);

        return {
            dateFrom: formatDate(firstDay),
            dateTo: formatDate(lastDay),
        };
    };
    const [filters, setFilters] = useSessionState('deliveryList.filters', {
        companyId: null,
        clientId: null,
        chantierId: null,
        commercialId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        regle: -1, //0 non, 1 oui, -1 tous
        facture: -1, //0 non facture, 1 facture, -1 tous
        accuse: -1,
        query: '',
        status: "",
        amount: '',
        month: '',
    });
    const [visibleColumns, setVisibleColumns] = useState(() => {
        const defaultColumns = {
            numero: true,
            commandeNumero: true,
            company: true,
            client: true,
            chantier: true,
            createdBy: true,
            createdAt: true,
            dateOperation: true,
            commercial: true,
            modeReglement: true,
            montantTotalTTC: true,
            montantTotalHT: true,
            montantTotalTaxe: true,
            montantPaye: true,
            status: true,
            accuse: true,
            estRegle: true,
            estFacture: true,
        };

        if (typeof window === 'undefined') {
            return defaultColumns;
        }

        try {
            const savedColumns = window.localStorage.getItem('deliveryListVisibleColumns');
            return savedColumns ? { ...defaultColumns, ...JSON.parse(savedColumns) } : defaultColumns;
        } catch {
            return defaultColumns;
        }
    });
    const [selectedClient, setSelectedClient] = useState(null);
    const defaultCompanyId = useMemo(
        () => companies?.find((item) => item.isDefault)?.id ?? null,
        [companies]
    );
    const [sortConfig, setSortConfig] = useSessionState('deliveryList.sortConfig', { key: null, direction: 'asc' });
    const [currentPage, setCurrentPage] = useSessionState('deliveryList.currentPage', 1);
    const [rowsPerPage, setRowsPerPage] = useSessionState('deliveryList.rowsPerPage', 10);
    const didRestoreListState = useRef(false);

    const searchInputRef = useRef(null);

    const reglementOptions = [
        { value: -1, label: t('common.all', 'Tous') },
        { value: 0, label: t('reglement.nonRegle', 'Non réglé') },
        { value: 1, label: t('reglement.regle', 'Réglé') },
    ];

    const accuseOptions = [
        { value: -1, label: t('common.all', 'Tous') },
        { value: 0, label: t('delivery.nonAccuse', 'Non accusé') },
        { value: 1, label: t('delivery.accuse', 'Accusé') },
    ];

    const factureOptions = [
        { value: -1, label: t('common.all', 'Tous') },
        { value: 0, label: t('delivery.nonFacture', 'Non facture') },
        { value: 1, label: t('delivery.facture', 'Facture') },
    ];

    const statusOptions = [
        { value: "", label: t('common.all', 'Tous') },
        { value: "EN_PREPARATION", label: 'En préparation' },
        { value: "LIVRE", label: 'Livré' },
    ];

    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
        dispatch(commercialActions.list({ query: "" })); // Fetch categories on component mount
        dispatch(companyActions.getAll({}));
    }, []);

    useEffect(() => {
        if (defaultCompanyId && filters.companyId == null) {
            setFilters((prev) => ({ ...prev, companyId: defaultCompanyId }));
        }
    }, [defaultCompanyId]);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    }, [filters.regle, filters.facture, filters.accuse, filters.status, filters.companyId, filters.clientId, filters.chantierId, filters.dateFrom, filters.dateTo, filters.commercialId, filters.amount]);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        window.localStorage.setItem('deliveryListVisibleColumns', JSON.stringify(visibleColumns));
    }, [visibleColumns]);

    // Handle checkbox change for delivery selection
    const handleCheckboxChange = (deliveryId) => {
        setCheckedDeliveries((prevChecked) => {
            if (prevChecked.includes(deliveryId)) {
                return prevChecked.filter((id) => id !== deliveryId);
            } else {
                return [...prevChecked, deliveryId];
            }
        });
    };

    const toggleColumnVisibility = (columnKey) => {
        setVisibleColumns((prev) => ({
            ...prev,
            [columnKey]: !prev[columnKey],
        }));
    };

    const clearFilters = () => {
        setFilters({
            query: '',
            companyId: defaultCompanyId,
            clientId: null,
            chantierId: null,
            commercialId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate),
            regle: -1,
            facture: -1,
            accuse: -1,
            status: '',
            amount: '',
            month: '',
        });
        debouncedSearch('')
    };

    const getDateSortValue = (value) => {
        if (!value) {
            return 0;
        }

        if (value instanceof Date) {
            return value.getTime() || 0;
        }

        const dateText = String(value).trim();
        const dateOnly = dateText.split(/[T\s]/)[0];
        const isoMatch = dateOnly === dateText ? dateOnly.match(/^(\d{4})-(\d{2})-(\d{2})$/) : null;
        const frMatch = dateOnly.match(/^(\d{2})[/-](\d{2})[/-](\d{4})$/);

        if (isoMatch) {
            const [, year, month, day] = isoMatch.map(Number);
            return new Date(year, month - 1, day).getTime();
        }

        if (frMatch) {
            const [, day, month, year] = frMatch.map(Number);
            return new Date(year, month - 1, day).getTime();
        }

        return new Date(dateText).getTime() || 0;
    };

    const getSortValue = (bl, key) => {
        switch (key) {
            case 'numero':
                return bl.numero || '';
            case 'commandeNumero':
                return bl.commandeNumero || '';
            case 'companyName':
                return bl.companyName || '';
            case 'clientNom':
                return bl.clientNom || '';
            case 'chantierNom':
                return bl.chantierNom || '';
            case 'createdBy':
                return bl.createdBy || '';
            case 'createdAt':
                return getDateSortValue(bl.createdAt);
            case 'dateOperation':
                return getDateSortValue(bl.dateOperation);
            case 'commercialNom':
                return bl.commercialNom || '';
            case 'modeReglement':
                return getModeReglementLabel(bl.modeReglement);
            case 'montantTotalTTC':
                return Number(bl.montantTotalTTC || 0);
            case 'montantTotalHT':
                return Number(bl.montantTotalHT || 0);
            case 'montantTotalTaxe':
                return Number(bl.montantTotalTaxe || 0);
            case 'montantPaye':
                return Number(bl.montantPayeEffectif ?? bl.montantPaye ?? 0);
            default:
                return '';
        }
    };

    const sortedDeliveries = useMemo(() => {
        const rows = [...(list || [])];
        if (!sortConfig.key) return rows;

        rows.sort((a, b) => {
            const left = getSortValue(a, sortConfig.key);
            const right = getSortValue(b, sortConfig.key);

            if (typeof left === 'number' && typeof right === 'number') {
                return sortConfig.direction === 'asc' ? left - right : right - left;
            }

            return sortConfig.direction === 'asc'
                ? String(left).localeCompare(String(right), undefined, { numeric: true, sensitivity: 'base' })
                : String(right).localeCompare(String(left), undefined, { numeric: true, sensitivity: 'base' });
        });

        return rows;
    }, [list, sortConfig]);

    const totalPages = Math.max(1, Math.ceil(sortedDeliveries.length / rowsPerPage));
    const currentPageSafe = Math.min(currentPage, totalPages);
    const paginatedDeliveries = useMemo(() => {
        const startIndex = (currentPageSafe - 1) * rowsPerPage;
        return sortedDeliveries.slice(startIndex, startIndex + rowsPerPage);
    }, [sortedDeliveries, currentPageSafe, rowsPerPage]);

    useEffect(() => {
        if (!didRestoreListState.current) {
            didRestoreListState.current = true;
            return;
        }
        setCurrentPage(1);
	    }, [
	        filters.regle,
	        filters.facture,
	        filters.accuse,
        filters.status,
        filters.companyId,
        filters.clientId,
        filters.chantierId,
        filters.dateFrom,
        filters.dateTo,
        filters.commercialId,
        filters.amount,
        filters.query,
        filters.month,
        rowsPerPage,
    ]);

    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(totalPages);
        }
    }, [currentPage, totalPages]);

    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
        }));
    };

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const renderSortableHeader = (label, key) => (
        <th
            className="align-middle text-center"
            onClick={() => handleSort(key)}
            style={{ cursor: 'pointer', userSelect: 'none' }}
        >
            {label}{sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
        </th>
    );

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    const companyOptions = companies?.map(item => ({
        value: item.id,
        label: item.name,
    })) ?? [];

    const companyOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...companyOptions
    ];
    const columnOptions = [
        { key: 'numero', label: t('delivery.numero') },
        { key: 'commandeNumero', label: t('delivery.bcNumero') },
        { key: 'company', label: t('company.title', 'Entreprise') },
        { key: 'client', label: t('commande.client') },
        { key: 'chantier', label: t('delivery.chantier') },
        { key: 'createdBy', label: t('common.user') },
        { key: 'createdAt', label: t('commande.dateCreation') },
        { key: 'dateOperation', label: t('delivery.dateOperation') },
        { key: 'commercial', label: t('delivery.commercial') },
        { key: 'modeReglement', label: t('facture.modeReglement', 'Mode de reglement') },
        { key: 'montantTotalTTC', label: t('devis.montantTTC') },
        { key: 'montantTotalHT', label: t('devis.montantHT') },
        { key: 'montantTotalTaxe', label: t('devis.montantTVA') },
        { key: 'montantPaye', label: t('reglement.montantPaye') },
        { key: 'status', label: t('delivery.status') },
        { key: 'accuse', label: t('delivery.accuse') },
        { key: 'estRegle', label: t('delivery.regle') },
        { key: 'estFacture', label: t('delivery.facture') },
    ];
    const getDeliveryNetAmount = (delivery) => Math.max(Number(
        delivery?.montantNet ?? (Number(delivery?.montantTotalTTC || 0) - Number(delivery?.montantRetourne || 0))
    ), 0);
    const getDeliveryRemainingAmount = (delivery) => Math.max(Number(
        delivery?.montantRestantGlobal ?? delivery?.montantRestant ?? (
            getDeliveryNetAmount(delivery) - Number(delivery?.montantPaye || delivery?.montantRegle || 0)
        )
    ), 0);
    const getDeliveryEffectivePaidAmount = (delivery) => Math.max(Number(
        delivery?.montantPayeEffectif ?? (
            getDeliveryNetAmount(delivery) - getDeliveryRemainingAmount(delivery)
        )
    ), 0);
    const isDeliveryPaid = (delivery) => (
        Number(delivery?.montantTotalTTC || 0) > 0 && getDeliveryRemainingAmount(delivery) <= 0
    );
    const totalMontantTTC = list.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0);
    const totalMontantHT = list.reduce((sum, bl) => sum + (bl.montantTotalHT || 0), 0);
    const totalMontantTaxe = list.reduce((sum, bl) => sum + (bl.montantTotalTaxe || 0), 0);
    const totalMontantPaye = list.reduce((sum, bl) => sum + getDeliveryEffectivePaidAmount(bl), 0);
    const totalMontantPayeViaFactures = list.reduce((sum, bl) => sum + Number(bl.montantPayeViaFactures || 0), 0);
    const totalMontantRetourne = list.reduce((sum, bl) => sum + Number(bl.montantRetourne || 0), 0);
    const totalMontantRestant = list.reduce((sum, bl) => sum + getDeliveryRemainingAmount(bl), 0);
    const pageStart = sortedDeliveries.length === 0 ? 0 : (currentPageSafe - 1) * rowsPerPage + 1;
    const pageEnd = Math.min(currentPageSafe * rowsPerPage, sortedDeliveries.length);

    const refrechBLs = () => {
        let payload = {
            ...filters,
        };
        dispatch(deliveryActions.list(payload));
    };

    const commercialOptions = commercialList?.map(com => ({
        value: com.id,
        label: com.fullName,
    })) ?? [];

    const commercialOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...commercialOptions
    ];
    const compactSelectStyles = {
        control: (base) => ({
            ...base,
            minHeight: '31px',
            fontSize: '0.875rem',
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '0 8px',
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: '31px',
        }),
        clearIndicator: (base) => ({
            ...base,
            padding: '4px',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: '4px',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };

    const getSelectedDeliveryNotes = () =>
        list.filter(note => checkedDeliveries.includes(note.id));

    const isDeliveryInvoiced = (delivery) =>
        Boolean(delivery?.estFacture) || Boolean(delivery?.numeroFacture);

    const validateGroupedDeliverySelection = (selectedDeliveryNotes) => {
        if (selectedDeliveryNotes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.noDeliveriesSelected'),
            });
            return false;
        }

        const firstClient = selectedDeliveryNotes[0].clientId;
        const firstCompany = selectedDeliveryNotes[0].companyId;
        const allSameClient = selectedDeliveryNotes.every(note => note.clientId === firstClient);
        const allSameCompany = selectedDeliveryNotes.every(note => note.companyId === firstCompany);
        const allConfirmed = selectedDeliveryNotes.every(note => note.status === 'LIVRE');

        if (!allSameClient) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notesFromDifferentClients'),
            });
            return false;
        }

        if (!allSameCompany) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notesFromDifferentCompanies', 'Impossible de creer une facture a partir de BLs de differentes entreprises.'),
            });
            return false;
        }

        if (!allConfirmed) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('delivery.notAllDelivered'),
            });
            return false;
        }

        return true;
    };

    const aggregateDeliveryLines = (selectedDeliveryNotes) => {
        const roundMoney = roundToNearestInteger;
        const roundUnitPrice = value => Math.round((Number(value || 0) + Number.EPSILON) * 1000000) / 1000000;
        return selectedDeliveryNotes.flatMap(note =>
            (note.lignes || []).filter(line => Number(line.quantiteDisponible ?? line.quantiteLivree ?? line.quantite ?? 0) > 0).map(line => {
                const qty = Number(line.quantiteLivree ?? line.quantite ?? 0);
                const availableQty = Number(line.quantiteDisponible ?? qty);
                const prixTTC = Number(line.prixUnitaireTTC || 0);
                const discount = Number(line.remise || 0);
                const vat = Number(line.tauxTVA || 0) > 1 ? Number(line.tauxTVA) / 100 : Number(line.tauxTVA || 0);
                const prixHT = roundUnitPrice(prixTTC / (1 + vat));
                const montantTTC = roundMoney(prixTTC * availableQty * (1 - discount / 100));
                const montantHT = roundMoney(montantTTC / (1 + vat));
                const montantTVA = roundMoney(montantTTC - montantHT);
                return {
                    articleId: line.articleId,
                    articleCode: line.articleCode,
                    articleNom: line.articleNom,
                    unite: line.unite,
                    prixUnitaireHT: prixHT,
                    prixUnitaireTTC: prixTTC,
                    tauxTVA: vat,
                    remise: discount,
                    quantite: availableQty,
                    montantHT,
                    montantTVA,
                    montantTTC,
                    sourceBonLivraisonId: note.id,
                    sourceBonLivraisonNumero: note.numero,
                    sourceLigneBonLivraisonId: line.id,
                    quantiteLivree: qty,
                    quantiteRetournee: Number(line.quantiteRetournee || 0),
                    quantiteDejaFacturee: Number(line.quantiteDejaFacturee || 0),
                    quantiteDisponible: Number(line.quantiteDisponible ?? qty)
                };
            })
        );
    };

    const buildGroupedDocumentContext = (selectedDeliveryNotes) => {
        const lignes = aggregateDeliveryLines(selectedDeliveryNotes);
        const firstDelivery = selectedDeliveryNotes[0];

        return {
            firstDelivery,
            lignes,
            montantTotalHT: Math.round((lignes.reduce((total, line) => total + Number(line.montantHT || 0), 0) + Number.EPSILON) * 100) / 100,
            montantTotalTaxe: Math.round((lignes.reduce((total, line) => total + Number(line.montantTVA || 0), 0) + Number.EPSILON) * 100) / 100,
            montantTotalTTC: Math.round((lignes.reduce((total, line) => total + Number(line.montantTTC || 0), 0) + Number.EPSILON) * 100) / 100,
            numeros: selectedDeliveryNotes.map(note => note.numero).filter(Boolean),
        };
    };

    // Handle creating an invoice from selected deliveries
    const handleCreateInvoice = () => {
        const selectedDeliveryNotes = getSelectedDeliveryNotes();
        if (!validateGroupedDeliverySelection(selectedDeliveryNotes)) return;
        const groupedDocument = buildGroupedDocumentContext(selectedDeliveryNotes);
        if (groupedDocument.lignes.length === 0) {
            Swal.fire({ icon: 'warning', title: t('common.warning'), text: 'Aucune quantite disponible a facturer.' });
            return;
        }

        // Prepare the invoice object
        const newInvoice = {
            clientId: selectedDeliveryNotes[0].clientId,
            clientLivreId: selectedDeliveryNotes[0].clientId,
            clientNom: selectedDeliveryNotes[0].clientNom,
            companyId: selectedDeliveryNotes[0].companyId || '',
            companyName: selectedDeliveryNotes[0].companyName || '',
            deliveryMappings: selectedDeliveryNotes.map(note => ({
                id: note.id,
                numero: note.numero,
                dateLivraison: note.dateLivraison,
                montantTTC: note.montantTotalTTC,
                montantPaye: note.montantPaye,
                montantPaiementAssocieBL: note.montantPaiementAssocieBL,
                montantPaiementTransfereFactures: note.montantPaiementTransfereFactures,
                montantRetourne: note.montantRetourne,
                montantNet: note.montantNet
            })),
            lignes: groupedDocument.lignes,
            bonLivraionsRefs: groupedDocument.numeros.join(','),

            montantTotalHT: groupedDocument.montantTotalHT,
            montantTotalTaxe: groupedDocument.montantTotalTaxe,
            montantTotalTTC: groupedDocument.montantTotalTTC,
            montantTotalPaye: selectedDeliveryNotes.reduce(
                (total, note) => total + Number(note.montantPaiementAssocieBL ?? note.montantPaye ?? 0), 0),
            montantRegle: 0,
            transfererPaiementsBL: true,
            modePaiement: selectedDeliveryNotes[0].modePaiement,
            modeReglement: selectedDeliveryNotes[0].modeReglement,
            dateFacture: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }), // Current date in YYYY-MM-DD format
            dateEcheance: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }), // Current date in YYYY-MM-DD format
            // dateEcheanceCheque: selectedDeliveryNotes[0].dateEcheanceCheque,
            // banque: selectedDeliveryNotes[0].banque,
            // numeroCheque: selectedDeliveryNotes[0].numeroCheque,
        };

        const invoiceFormPath = location.pathname.startsWith('/sales-module')
            ? '/sales-module/invoices/new'
            : '/ventes/factures/new';
        navigate(invoiceFormPath, {
            state: {
                initialValues: newInvoice,
                returnTo: location.pathname,
                source: 'BON_LIVRAISON'
            }
        });
    };

    const generateRecapDocument = async (groupedDocument, withPrices = true) => {
        const { firstDelivery, lignes, montantTotalHT, montantTotalTaxe, montantTotalTTC, numeros } = groupedDocument;

        const seller = {
            companyName: firstDelivery.companyName || company?.name || businessName || '',
            companySubtitle: company?.subtitle || '',
            companyAddress: company?.address || address || '',
            companyPhone1: company?.phone1 || telephone || '',
            companyPhone2: company?.phone2 || '',
            companyEmail: company?.email || '',
            companyIce: company?.ice || '',
            companyRc: company?.rc || '',
            companyPatente: company?.patente || '',
            companyIf: company?.if || '',
            companyCnss: company?.cnss || '',
        };

        await generateDoc('recap_document', {
            seller,
            buyer: {
                name: firstDelivery.clientNom || '',
                lines: [
                    firstDelivery.chantierNom ? `Chantier: ${firstDelivery.chantierNom}` : null,
                    numeros.length ? `BLs: ${numeros.join(', ')}` : null,
                ].filter(Boolean),
            },
            meta: {
                number: `REC-${new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' })}`,
                date: new Date().toLocaleDateString('fr-MA', { timeZone: 'Africa/Casablanca' }),
                payment: firstDelivery.modeReglement,
            },
            items: lignes.map((line) => ({
                label: line.articleNom || '',
                sublabel: [line.articleCode, line.unite].filter(Boolean).join(' • ') || undefined,
                qty: line.quantite,
                unit: line.unite || '',
                unitHT: line.prixUnitaireHT,
                unitTTC: line.prixUnitaireTTC,
                totalHT: line.montantHT,
                totalTVA: line.montantTVA,
                totalTTC: line.montantTTC,
            })),
            totals: {
                HT: montantTotalHT,
                TVA: montantTotalTaxe,
                TTC: montantTotalTTC,
            },
            showPrices: withPrices,
            priceMode: 'TTC',
            open: true,
            download: false,
        });
    };

    const handlePrintRecapDocument = async (withPrices = true) => {
        const selectedDeliveryNotes = getSelectedDeliveryNotes();
        if (!validateGroupedDeliverySelection(selectedDeliveryNotes)) return;
        const groupedDocument = buildGroupedDocumentContext(selectedDeliveryNotes);
        await generateRecapDocument(groupedDocument, withPrices);
    };

    const handleGenerateRecapPdf = async (document, withPrices = true) => {
        const groupedDocument = buildGroupedDocumentContext([document]);
        await generateRecapDocument(groupedDocument, withPrices);
    };


    function getModeReglementLabel(mode) {
        switch (mode) {
            case 'ESPECES': return 'Espèces';
            case 'CARTE_BANCAIRE': return 'Carte bancaire';
            case 'CHEQUE': return 'Chèque';
            case 'VIREMENT': return 'Virement';
            case 'TRAITE': return 'Traite';
            default: return mode || '-';
        }
    }

    const formatClientSolde = (totalDebit, totalCredit) => {
        const debit = Number(totalDebit || 0);
        const credit = Number(totalCredit || 0);

        // RÈGLE MÉTIER : crédit - débit
        const solde = credit - debit;

        const sign = solde > 0 ? '+' : solde < 0 ? '-' : '';
        return `${sign}${formatPrice(Math.abs(solde), false)}`;
    };

    const handleGeneratePdf = async (
        document,
        documentType = 'bon_livraison',
        withPrices = true,
        format = "A4"
    ) => {

        if (format === "TH") {
            await generateThermiquePDF(document)
        } else {
            await generateDoc(documentType, {
                matjarDoc: document,
                sellerModel: company,
                currency: "MAD",

                showPrices: withPrices,
                format,           // ✅ A4 | A5

                open: true,
                download: false,
            });
        }

    };

    const generateThermiquePDF = async (receiptData) => {
        console.log(receiptData)
        try {
            const doc = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: [80, 350], // slightly taller for bigger fonts
            });

            const pageWidth = 80;
            const margin = 4;
            let y = 8;

            /* ================= HEADER ================= */
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(18);

            const companyTitle = businessName || 'MATJARPOS';
            const titleLines = doc.splitTextToSize(
                companyTitle,
                pageWidth - margin * 2
            );

            titleLines.forEach((line, index) => {
                doc.text(line, pageWidth / 2, y + index * 7, { align: 'center' });
            });

            y += titleLines.length * 7 + 3;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);

            if (address) {
                const lines = doc.splitTextToSize(address, pageWidth - margin * 2);
                lines.forEach((l, i) =>
                    doc.text(l, pageWidth / 2, y + i * 5, { align: 'center' })
                );
                y += lines.length * 5;
            }

            if (telephone) {
                doc.text(telephone, pageWidth / 2, y + 5, { align: 'center' });
                y += 8;
            }

            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            /* ================= INFO ================= */
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.text('REÇU DE VENTE', pageWidth / 2, y, { align: 'center' });
            y += 7;

            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);

            doc.text(`N° : ${receiptData?.numero || '-'}`, margin, y);
            y += 6;
            doc.text(`Date : ${receiptData?.createdAt || '-'}`, margin, y);
            y += 6;

            doc.text(`Vendeur : ${receiptData?.createdBy || '---'}`, margin, y);
            y += 6;

            doc.text(`Client : ${receiptData?.clientNom || 'Passager'}`, margin, y);
            y += 6;

            doc.line(margin, y, pageWidth - margin, y);
            y += 5;

            /* ================= ARTICLES HEADER ================= */
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);

            doc.text('Article', margin, y);
            doc.text('Qté', pageWidth - 42, y, { align: 'center' });
            doc.text('PU', pageWidth - 26, y, { align: 'right' });
            doc.text('Total', pageWidth - margin, y, { align: 'right' });

            y += 4;
            doc.line(margin, y, pageWidth - margin, y);
            y += 4;

            /* ================= ARTICLES LINES ================= */
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);

            receiptData?.lignes?.forEach(item => {
                const name =
                    item.articleNom.length > 20
                        ? item.articleNom.slice(0, 20) + '…'
                        : item.articleNom;

                const qte = Number(item.quantiteLivree || 0);
                const pu = Number(item.prixUnitaireTTC || 0);
                const total = Number(item.montantTTC || qte * pu);

                doc.text(name, margin, y);
                doc.text(String(qte), pageWidth - 42, y, { align: 'center' });
                doc.text(formatPrice(pu, false), pageWidth - 26, y, { align: 'right' });
                doc.text(formatPrice(total, false), pageWidth - margin, y, {
                    align: 'right',
                });

                y += 7;
            });

            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            /* ================= TOTAL ================= */
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(14);

            doc.text('TOTAL TTC', margin, y);
            doc.text(
                formatPrice(receiptData?.montantTotalTTC, false),
                pageWidth - margin,
                y,
                { align: 'right' }
            );

            y += 8;
            doc.line(margin, y, pageWidth - margin, y);
            y += 6;

            /* ================= PAIEMENT ================= */
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(11);

            const modeLabel = getModeReglementLabel(receiptData?.modeReglement);
            doc.text(`Mode paiement : ${modeLabel}`, margin, y);
            y += 6;

	            doc.text('Montant payé :', margin, y);
	            doc.text(
	                formatPrice(getDeliveryEffectivePaidAmount(receiptData), false),
                pageWidth - margin,
                y,
                { align: 'right' }
            );
            y += 6;

            if (
                receiptData?.modeReglement === 'ESPECES' &&
                receiptData?.montantPaye > receiptData?.montantTotalTTC
            ) {
                doc.text('Monnaie :', margin, y);
                doc.text(
                    formatPrice(
                        receiptData.montantPaye - receiptData.montantTotalTTC,
                        false
                    ),
                    pageWidth - margin,
                    y,
                    { align: 'right' }
                );
                y += 6;
            }

            doc.line(margin, y, pageWidth - margin, y);
            y += 7;

            /* ================= RESTE A PAYER ================= */
	            if (!receiptData?.isComptoir) {
	                const resteAPayer = getDeliveryRemainingAmount(receiptData);
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(12);
                doc.text('RESTE A PAYER', margin, y);

                doc.setFont('helvetica', 'normal');
                doc.text(
                    formatPrice(resteAPayer, false),
                    pageWidth - margin,
                    y,
                    { align: 'right' }
                );
                y += 8;
            }

            /* ================= FOOTER ================= */
            doc.setFontSize(11);
            doc.text('Merci de votre confiance', pageWidth / 2, y, {
                align: 'center',
            });
            y += 6;

            doc.text('Powered by MatjarPOS', pageWidth / 2, y, {
                align: 'center',
            });

            const blobUrl = doc.output('bloburl');
            window.open(blobUrl, '_blank');
        } catch (e) {
            console.error(e);
        }
    };



    const handleShowModal = () => {
        navigate('/sales-module/delivery/new');
    };

    const handleEdit = (bl) => {
        navigate('/sales-module/delivery/edit', { state: { bonLivraison: bl } });
    }

    const debouncedSearch = () => {
        dispatch(deliveryActions.list({
            ...filters,
        }));
    }

    const handleLivrerBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmLivrer'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, status: 'LIVRE' },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                    };
                    dispatch(deliveryActions.list(payload));

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    const handleAccuseBL = (bl) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('bonLivraison.confirmAccuser'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        }).then((result) => {
            if (!result.isConfirmed) return;
            let payload = {
                id: bl.id,
                data: { ...bl, accuse: true },
                onSuccess: () => {
                    Swal.fire({
                        icon: 'success',
                        title: t('common.updated'),
                        text: t('bonLivraison.updatedSuccess'),
                    });
                    let payload = {
                        ...filters,
                    };
                    dispatch(deliveryActions.list(payload));

                },
            };
            dispatch(deliveryActions.update(payload));
        });
    }

    // Aggregate lines by articleId for display/export
    const aggregateLines = (lines) => {
        const lineMap = {};
        lines.forEach(line => {
            const key = line.articleId;
            if (!lineMap[key]) {
                lineMap[key] = {
                    ...line,
                    quantite: 0,
                    montantHT: 0,
                    montantTVA: 0,
                    montantTTC: 0,
                };
            }
            lineMap[key].quantite += line.quantite;
            lineMap[key].montantHT += line.montantHT || (line.quantite * line.prixUnitaireHT);
            lineMap[key].montantTVA += line.montantTVA || (line.quantite * line.prixUnitaireHT * line.tauxTVA);
            lineMap[key].montantTTC += line.montantTTC || (line.quantite * line.prixUnitaireHT * (1 + line.tauxTVA));
        });
        return Object.values(lineMap);
    };

    const handleAnnulerBLLight = (br) => {
        Swal.fire({
            title: t('delivery.deleteConfirmTitle'),
            text: t('delivery.deleteConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    let payload = {
                        id: br.id,
                        onSuccess: () => {
                            Swal.fire(t('delivery.deleted'), '', 'success');
                            refrechBLs();
                        },
                        onError: (error) => {
                            Swal.fire({
                                icon: 'error',
                                title: t('delivery.deleteError'),
                                text: t('delivery.deleteErrorMessage')
                            });
                        }
                    }
                    dispatch(deliveryActions.annulerBLLight(payload));

                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: t('common.error'),
                        text: t('delivery.deleteError')
                    });
                }
            }
        });
    }

    //Action for Super Admin
    const handleAnnulerBLHard = (br) => {
        Swal.fire({
            title: t('delivery.deleteConfirmTitle'),
            text: t('delivery.deleteConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    let payload = {
                        id: br.id,
                        onSuccess: () => {
                            Swal.fire(t('delivery.deleted'), '', 'success');
                            refrechBLs();
                        },
                        onError: (error) => {
                            Swal.fire({
                                icon: 'error',
                                title: t('delivery.deleteError'),
                                text: t('delivery.deleteErrorMessage')
                            });
                        }
                    }
                    dispatch(deliveryActions.annulerBLHard(payload));

                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: t('common.error'),
                        text: t('delivery.deleteError')
                    });
                }
            }
        });
    }

    //Action for Super Admin
    const handleResetBL = (br) => {
        Swal.fire({
            title: t('delivery.resetConfirmTitle'),
            text: t('delivery.resetConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    let payload = {
                        id: br.id,
                        onSuccess: () => {
                            Swal.fire(t('delivery.reseted'), '', 'success');
                            refrechBLs();
                        },
                        onError: (error) => {
                            console.log(error)
                            Swal.fire({
                                icon: 'error',
                                title: t('delivery.resetError'),
                                text: error
                            });
                        }
                    }
                    dispatch(deliveryActions.resetBL(payload));

                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: t('common.error'),
                        text: t('delivery.resetError')
                    });
                }
            }
        });
    }



    return (
        <Container fluid className="enterprise-page document-enterprise-page">
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaTruck className="text-primary me-2" />
                                {t('delivery.list')}
                            </h4>
                            <div className="d-flex align-items-center gap-2" style={{ minWidth: '420px' }}>
                                <div style={{ minWidth: '240px' }}>
                                    <Select
                                        options={companyOptionsWithAll}
                                        value={companyOptionsWithAll.find(o => o.value === filters.companyId)}
                                        onChange={o => setFilters(f => ({ ...f, companyId: o?.value ?? null }))}
                                        placeholder={t('company.selectCompany', 'Filtrer par entreprise')}
                                        isClearable
                                        isSearchable
                                        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                        styles={{
                                            menuPortal: base => ({ ...base, zIndex: 9999 })
                                        }}
                                    />
                                </div>
                                <UncontrolledDropdown>
                                    <DropdownToggle caret color="light" className="border">
                                        {t('common.columns', 'Colonnes')}
                                    </DropdownToggle>
                                    <DropdownMenu end className="p-2" style={{ minWidth: '260px' }}>
                                        {columnOptions.map((column) => (
                                            <label
                                                key={column.key}
                                                className="d-flex align-items-center gap-2 px-2 py-1 mb-0"
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <Input
                                                    type="checkbox"
                                                    checked={visibleColumns[column.key]}
                                                    onChange={() => toggleColumnVisibility(column.key)}
                                                />
                                                <span>{column.label}</span>
                                            </label>
                                        ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                                {/* Primary actions */}
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="me-2" /> {t('delivery.new')}
                                </Button>
                                {checkedDeliveries.length > 0 && (
                                    <Button color="info" onClick={handlePrintRecapDocument}>
                                        <FaFilePdf className="me-2" />
                                        Récap document
                                    </Button>
                                )}
                                {checkedDeliveries.length > 0 && (
                                    <Button color="success" onClick={handleCreateInvoice}>
                                        <FaFileInvoice className="me-2" />
                                        {t('delivery.createInvoice')}
                                    </Button>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    <>
                            <div className="filter-container mb-4">
                                <Row className="g-2 align-items-end">

                                    {/* 🔍 SEARCH */}
                                    <Col xl={2} lg={3} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('common.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light py-1 px-2">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('bonLivraison.searchPlaceholder')}
                                                    value={filters.query}
                                                    className="text-uppercase form-control-sm"
                                                    onChange={e =>
                                                        setFilters(f => ({ ...f, query: e.target.value.toUpperCase() }))
                                                    }
                                                    onKeyDown={e => e.key === 'Enter' && debouncedSearch()}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>


                                    <Col xl={1} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('common.amount', 'Montant')}</Label>
                                            <Input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                placeholder={t('common.amount', 'Montant')}
                                                value={filters.amount}
                                                bsSize="sm"
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, amount: e.target.value }))
                                                }
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 👤 CLIENT */}
                                    <Col xl={2} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('bonLivraison.client')}</Label>
                                            <Select
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(o => o.value === filters.clientId)}
                                                onChange={o => {
                                                    setFilters(f => ({ ...f, clientId: o?.value ?? null }));
                                                    setSelectedClient(o);
                                                }}
                                                isClearable
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                styles={compactSelectStyles}
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 🏗️ CHANTIER */}
                                    <Col xl={1} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('chantier.title', 'Chantier')}</Label>
                                            <Select
                                                options={chantierOptionsWithAll}
                                                value={chantierOptionsWithAll.find(o => o.value === filters.chantierId)}
                                                onChange={o =>
                                                    setFilters(f => ({ ...f, chantierId: o?.value ?? null }))
                                                }
                                                isClearable
                                                menuPortalTarget={document.body}
                                                styles={compactSelectStyles}
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 👔 COMMERCIAL */}
                                    <Col xl={1} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('commercial.title', 'Commercial')}</Label>
                                            <Select
                                                options={commercialOptionsWithAll}
                                                value={commercialOptionsWithAll.find(o => o.value === filters.commercialId)}
                                                onChange={o =>
                                                    setFilters(f => ({ ...f, commercialId: o?.value ?? null }))
                                                }
                                                isClearable
                                                menuPortalTarget={document.body}
                                                styles={compactSelectStyles}
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 💰 STATUT PAIEMENT */}
                                    <Col xl={1} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('reglement.status', 'Paiement')}</Label>
                                            <Input
                                                type="select"
                                                value={filters.regle}
                                                bsSize="sm"
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, regle: e.target.value }))
                                                }
                                            >
                                                {reglementOptions.map(opt => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col xl={1} lg={2} md={6}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('delivery.accuse', 'Accusé')}</Label>
                                            <Input
                                                type="select"
                                                value={filters.accuse}
                                                bsSize="sm"
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, accuse: Number(e.target.value) }))
                                                }
                                            >
                                                {accuseOptions.map(opt => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
	                                    <Col xl={1} lg={2} md={6}>
	                                        <FormGroup className="mb-0">
	                                            <Label className="mb-1 small">{t('delivery.facture', 'Facture')}</Label>
	                                            <Input
	                                                type="select"
	                                                value={filters.facture}
	                                                bsSize="sm"
	                                                onChange={e =>
	                                                    setFilters(f => ({ ...f, facture: Number(e.target.value) }))
	                                                }
	                                            >
	                                                {factureOptions.map(opt => (
	                                                    <option key={opt.value} value={opt.value}>
	                                                        {opt.label}
	                                                    </option>
	                                                ))}
	                                            </Input>
	                                        </FormGroup>
	                                    </Col>
	                                    <Col xl={1} lg={2} md={6}>
	                                        <FormGroup className="mb-0">
	                                            <Label className="mb-1 small">Status</Label>
                                            <Input
                                                type="select"
                                                value={filters.status}
                                                bsSize="sm"
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, status: e.target.value }))
                                                }
                                            >
                                                {statusOptions.map(opt => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>

                                    {/* 📅 DATE FROM */}

                                    <Col xl={1} lg={2} md={3}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('common.month', 'Mois')}</Label>
                                            <Input
                                                type="month"
                                                value={filters.month}
                                                bsSize="sm"
                                                onChange={e => {
                                                    const month = e.target.value;
                                                    const { dateFrom, dateTo } = getMonthDateRange(month);
                                                    setFilters(f => ({
                                                        ...f,
                                                        month,
                                                        dateFrom: dateFrom || f.dateFrom,
                                                        dateTo: dateTo || f.dateTo,
                                                    }));
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xl={1} lg={2} md={3}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('common.from', 'Du')}</Label>
                                            <Input
                                                type="date"
                                                value={filters.dateFrom}
                                                bsSize="sm"
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, dateFrom: e.target.value, month: '' }))
                                                }
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* 📅 DATE TO */}
                                    <Col xl={1} lg={2} md={3}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('common.to', 'Au')}</Label>
                                            <Input
                                                type="date"
                                                value={filters.dateTo}
                                                bsSize="sm"
                                                onChange={e =>
                                                    setFilters(f => ({ ...f, dateTo: e.target.value, month: '' }))
                                                }
                                            />
                                        </FormGroup>
                                    </Col>

                                    {/* ♻️ CLEAR */}
                                    {/* <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col> */}
                                    <Col xl={1} lg={2} md={3}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1 small">{t('common.lines', 'Lignes')}</Label>
                                            <Input
                                                type="select"
                                                value={rowsPerPage}
                                                bsSize="sm"
                                                onChange={e => setRowsPerPage(Number(e.target.value))}
                                            >
                                                {[10, 20, 50, 100].map((size) => (
                                                    <option key={size} value={size}>
                                                        {size}
                                                    </option>
                                                ))}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            {loading && (
                                <div className="d-flex align-items-center gap-2 mb-3 text-muted small">
                                    <Spinner size="sm" color="primary" />
                                    <span>{t('common.loading')}</span>
                                </div>
                            )}
                            {/* Summary Statistics Box */}

                            <div className="enterprise-table-scroll">
                            <table className="table table-hover table-striped table-bordered document-grouped-table" style={{ fontSize: '0.8rem' }}>
                                <thead className="thead-light">
                                    <tr>
                                        {/* Add checkbox column */}
                                        <th className="align-middle text-center" width="20">
                                            <div className="form-check">
                                                <Input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Only select deliveries that are in LIVRE status
                                                            const deliveredIds = list
                                                                .filter(bl => bl.status === 'LIVRE' && !bl.estFacture)
                                                                .map(bl => bl.id);
                                                            setCheckedDeliveries(deliveredIds);
                                                        } else {
                                                            setCheckedDeliveries([]);
                                                        }
                                                    }}
                                                    checked={
                                                        checkedDeliveries.length > 0 &&
                                                        checkedDeliveries.length === list.filter(bl => bl.status === 'LIVRE' && !bl.estFacture).length
                                                    }
                                                />
                                            </div>
                                        </th>
                                        <th className="align-middle text-center">
                                            <div
                                                onClick={() => handleSort('numero')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                            >
                                                {t('delivery.numero')}
                                                {sortConfig.key === 'numero' && (sortConfig.direction === 'asc' ? ' ▲' : ' ▼')}
                                            </div>
                                            <div
                                                className="small text-muted mt-1"
                                                onClick={() => handleSort('dateOperation')}
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                            >
                                                {t('delivery.dateOperation')}
                                                {sortConfig.key === 'dateOperation' && (sortConfig.direction === 'asc' ? ' ▲' : ' ▼')}
                                            </div>
                                        </th>
                                        {renderSortableHeader(t('commande.client'), 'clientNom')}
                                        {renderSortableHeader(
                                            `${t('facture.table.amounts', 'Montants')} TTC`,
                                            'montantTotalTTC'
                                        )}
                                        <th className="align-middle text-center">{t('delivery.status')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
		                                    {paginatedDeliveries.map((bl) => {
		                                        const remainingAmount = getDeliveryRemainingAmount(bl);
		                                        const netAmount = getDeliveryNetAmount(bl);
		                                        const effectivePaidAmount = getDeliveryEffectivePaidAmount(bl);
		                                        const paidViaInvoices = Number(bl.montantPayeViaFactures || 0);
		                                        const isPaid = isDeliveryPaid(bl);
	                                        const isInvoiced = isDeliveryInvoiced(bl);
	                                        const isUnpaid = bl.status === 'LIVRE' && !isPaid;
	                                        return (
	                                            <tr
	                                                key={bl.id}
	                                                className={isInvoiced ? 'delivery-row-invoiced' : isPaid ? 'table-success' : isUnpaid ? 'table-danger' : ''}
	                                            >
                                            {/* Add checkbox for each row */}
                                            <td className="align-middle text-center">
                                                {bl.status === 'LIVRE' && !bl.estFacture && (
                                                    <Input
                                                        type="checkbox"
                                                        checked={checkedDeliveries.includes(bl.id)}
                                                        onChange={() => handleCheckboxChange(bl.id)}
                                                    />
                                                )}
                                            </td>
                                            <td className="align-middle">
	                                                <div className="document-main-ref">{bl.numero}</div>
	                                                {isInvoiced && (
	                                                    <Badge color="primary" pill className="mt-1 delivery-invoiced-badge">
	                                                        {t('delivery.facture', 'Facture')}
	                                                    </Badge>
	                                                )}
	                                                {isPaid && (
                                                    <Badge color="success" pill className="mt-1">
                                                        {t('reglement.regle', 'Réglé')}
                                                    </Badge>
                                                )}
                                                {isUnpaid && (
                                                    <Badge color="danger" pill className="mt-1">
                                                        {t('reglement.nonRegle', 'Non réglé')}
                                                    </Badge>
                                                )}
                                                <div className="document-subtext">{t('delivery.bcNumero')}: {bl.commandeNumero || '-'}</div>
                                                <div className="document-subtext">{t('delivery.dateOperation')}: {bl.dateOperation || 'N/A'}</div>
                                                <div className="document-subtext">{t('commande.dateCreation')}: {bl.createdAt || 'N/A'}</div>
                                                <div className="document-subtext">{t('common.user')}: {bl.createdBy || 'N/A'}</div>
                                            </td>
                                            <td className="align-middle">
                                                <div className="document-strong">{bl.clientNom || 'N/A'}</div>
                                                <div className="document-subtext">{t('company.title', 'Entreprise')}: {bl.companyName || '-'}</div>
                                                <div className="document-subtext">{t('delivery.chantier')}: {bl.chantierNom || 'N/A'}</div>
                                                <div className="document-subtext">{t('delivery.commercial')}: {bl.commercialNom || 'LOCAL'}</div>
                                                <div className="document-subtext">{t('facture.modeReglement', 'Mode de reglement')}: {getModeReglementLabel(bl.modeReglement)}</div>
                                                {bl.notes && (
                                                    <div className="document-subtext">
                                                        {t('common.commentaire', 'Commentaire')}: {bl.notes}
                                                    </div>
                                                )}
                                            </td>
                                            <td className="align-middle">
	                                                <div className="document-amount-grid">
	                                                    <span>TTC</span><strong>{formatPrice(bl.montantTotalTTC, false)}</strong>
	                                                    <span>{t('delivery.returned', 'Retourné / avoir')}</span><span>{formatPrice(bl.montantRetourne || 0, false)}</span>
	                                                    <span>Net à régler</span><strong>{formatPrice(netAmount, false)}</strong>
	                                                    <span>{t('reglement.montantPaye')}</span><strong className={isPaid ? 'text-success' : ''}>{formatPrice(effectivePaidAmount, false)}</strong>
	                                                    {paidViaInvoices > 0 && <><span>Dont via facture</span><span>{formatPrice(paidViaInvoices, false)}</span></>}
	                                                    <span>{t('reglement.resteAPayer', 'Reste à payer')}</span><strong>{formatPrice(remainingAmount, false)}</strong>
	                                                </div>
                                            </td>
                                            <td className="align-middle text-center">
                                                {bl.status === 'EN_PREPARATION' && (
                                                    <span className="badge bg-warning">{t('delivery.enpreparation')}</span>
                                                )}
                                                {bl.status === 'EN_COURS' && (
                                                    <span className="badge bg-secondary">{t('delivery.encours')}</span>
                                                )}
                                                {bl.status === 'LIVRE' && (
                                                    <span className="badge bg-success">{t('delivery.livre')}</span>
                                                )}
                                                {bl.status === 'RETOUR' && (
                                                    <span className="badge bg-danger">{t('delivery.retourne')}</span>
                                                )}
                                                {bl.status === 'ANNULE' && (
                                                    <span className="badge bg-danger">{t('delivery.annule')}</span>
                                                )}
                                                <div className="document-subtext mt-1">
                                                    {t('delivery.accuse')}: {bl.accuse ? t('common.yes', 'Oui') : t('common.no', 'Non')}
                                                </div>
                                                <div className="document-subtext">
                                                    {t('delivery.regle')}:{' '}
                                                    {isPaid ? (
                                                        <span className="badge bg-success">{t('reglement.regle', 'Réglé')}</span>
                                                    ) : (
                                                        <span className="badge bg-danger">{t('reglement.nonRegle', 'Non réglé')}</span>
                                                    )}
                                                </div>
                                                <div className="document-subtext">
	                                                    {t('delivery.facture')}: {isInvoiced ? (
	                                                        <span className="badge bg-primary delivery-invoiced-badge">{t('common.yes', 'Oui')}</span>
	                                                    ) : t('common.no', 'Non')}
	                                                </div>
                                            </td>

                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    {/* Add dropdown for PDF options */}
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle caret color="secondary" size="sm" className="me-1">
                                                            <FaFilePdf />
                                                        </DropdownToggle>

                                                        <DropdownMenu>
                                                            {/* ===== A4 ===== */}
                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', true, 'A4')}
                                                            >
                                                                📄 BL A4 – avec prix
                                                            </DropdownItem>

                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', false, 'A4')}
                                                            >
                                                                📄 BL A4 – sans prix
                                                            </DropdownItem>

                                                            <DropdownItem divider />

                                                            {/* ===== A5 ===== */}
                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', true, 'A5')}
                                                            >
                                                                🧾 BL A5 – avec prix
                                                            </DropdownItem>

                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', false, 'A5')}
                                                            >
                                                                🧾 BL A5 – sans prix
                                                            </DropdownItem>

                                                            <DropdownItem
                                                                onClick={() => handleGeneratePdf(bl, 'bon_livraison', false, 'TH')}
                                                            >
                                                                🧾 BL Thermique
                                                            </DropdownItem>
                                                            <DropdownItem divider />

                                                            <DropdownItem
                                                                onClick={() => handleGenerateRecapPdf(bl, true)}
                                                            >
                                                                Récap AVEC prix
                                                            </DropdownItem>

                                                            <DropdownItem
                                                                onClick={() => handleGenerateRecapPdf(bl, false)}
                                                            >
                                                                Récap SANS prix
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>

                                                    {bl.status === 'EN_PREPARATION' && <Button
                                                        color="success"
                                                        title={t('bonLivraison.livrer')}
                                                        onClick={() => handleLivrerBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}
                                                    {bl.status === 'LIVRE' && !bl.accuse && <Button
                                                        color="success"
                                                        title={t('bonLivraison.accuser')}
                                                        onClick={() => handleAccuseBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}
                                                    <Button
                                                        color="warning"
                                                        title={t('commande.edit')}
                                                        onClick={() => handleEdit(bl)}
                                                        size="sm"
                                                        className="me-1"
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                    {/*<Button
                                                        color="danger"
                                                        title={t('commande.cancel')}
                                                        //onClick={() => handleDeleteDevis(commande.id)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaTrash />
                                                    </Button> */}
                                                    {bl.status === 'EN_PREPARATION' && <Button color="danger" size="sm" className="px-2 py-1">
                                                        <FaTrash size={12} onClick={() => handleAnnulerBLLight(bl)} />
                                                    </Button>}
                                                    {bl.status === 'LIVRE'  && isSuperAdmin && <Button color="danger" size="sm" className="px-2 py-1">
                                                        <FaTrash size={12} onClick={() => handleAnnulerBLHard(bl)} />
                                                    </Button>}
                                                    {bl.status === 'LIVRE' && isSuperAdmin && <Button
                                                        color="success"
                                                        title={t('commande.reset')}
                                                        onClick={() => handleResetBL(bl)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaRecycle />
                                                    </Button>}

                                                </div>
                                            </td>
                                            </tr>
                                        );
                                    })}
                                    {sortedDeliveries.length === 0 && (
                                        <tr>
                                            <td colSpan="6" className="text-center py-4">
                                                <div className="text-muted">{t('delivery.noBL')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="3" className="text-end">{t('common.totals')}</td>
                                        <td className="align-middle">
                                            <div className="document-amount-grid">
                                                <span>TTC</span><strong>{formatPrice(totalMontantTTC, false)}</strong>
	                                                <span>{t('delivery.returned', 'Retourné / avoir')}</span><span>{formatPrice(totalMontantRetourne, false)}</span>
	                                                <span>{t('reglement.montantPaye')}</span><span>{formatPrice(totalMontantPaye, false)}</span>
	                                                {totalMontantPayeViaFactures > 0 && <><span>Dont via facture</span><span>{formatPrice(totalMontantPayeViaFactures, false)}</span></>}
	                                                <span>{t('reglement.resteAPayer', 'Reste à payer')}</span><strong>{formatPrice(totalMontantRestant, false)}</strong>
                                            </div>
                                        </td>
                                        <td colSpan="2"></td>
                                    </tr>
                                </tfoot>
                            </table>
                            </div>
                            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mt-3">
                                <div className="text-muted small">
                                    {t('common.paginationInfo', {
                                        defaultValue: '{{start}}-{{end}} sur {{total}}',
                                        start: pageStart,
                                        end: pageEnd,
                                        total: sortedDeliveries.length,
                                    })}
                                </div>
                                <Pagination size="sm" className="mb-0">
                                    <PaginationItem disabled={currentPageSafe === 1}>
                                        <PaginationLink first onClick={() => handlePageChange(1)}>
                                            <FaAngleDoubleLeft />
                                        </PaginationLink>
                                    </PaginationItem>
                                    <PaginationItem disabled={currentPageSafe === 1}>
                                        <PaginationLink previous onClick={() => handlePageChange(currentPageSafe - 1)}>
                                            <FaAngleLeft />
                                        </PaginationLink>
                                    </PaginationItem>
                                    <PaginationItem disabled>
                                        <PaginationLink>
                                            {currentPageSafe} / {totalPages}
                                        </PaginationLink>
                                    </PaginationItem>
                                    <PaginationItem disabled={currentPageSafe === totalPages}>
                                        <PaginationLink next onClick={() => handlePageChange(currentPageSafe + 1)}>
                                            <FaAngleRight />
                                        </PaginationLink>
                                    </PaginationItem>
                                    <PaginationItem disabled={currentPageSafe === totalPages}>
                                        <PaginationLink last onClick={() => handlePageChange(totalPages)}>
                                            <FaAngleDoubleRight />
                                        </PaginationLink>
                                    </PaginationItem>
                                </Pagination>
                            </div>
                        </>
                </CardBody>
            </Card>
        </Container>
    );
};

export default DeliveryList;



